export default __webpack_public_path__ + "static/media/supportActive.e7205ad7.svg";